module.exports = __webpack_public_path__ + "img/courier_5.017503bc.png";